import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/me', label: 'Home', icon: 'M3 11l9-7 9 7v9a1 1 0 01-1 1h-5v-6h-6v6H4a1 1 0 01-1-1z', end: true },
  { to: '/me/booking', label: 'Booking', icon: 'M8 2v4M16 2v4M3 9h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z', end: false },
  { to: '/me/services', label: 'Services', icon: 'M12 3l9 4-9 4-9-4 9-4zm-9 9l9 4 9-4M3 17l9 4 9-4', end: false },
  { to: '/me/people', label: 'People', icon: 'M16 11a4 4 0 10-8 0 4 4 0 008 0zM4 21v-1a6 6 0 0112 0v1M17 11a3 3 0 100-6M20 21v-1a5 5 0 00-3-4.6', end: false },
  { to: '/me/payments', label: 'Payments', icon: 'M3 8a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2zM3 10h18M7 15h3', end: false },
];

function Unread({ n, className }: { n: number; className: string }) {
  if (n <= 0) return null;
  return (
    <span className={`rounded-full bg-danger px-1 text-center text-[10px] font-black leading-4 text-card ${className}`} aria-label={`${n} unread`}>
      {n > 99 ? '99+' : n}
    </span>
  );
}

/**
 * A signed-in passenger's tabs: along the bottom of a phone (`bottom`, the page leaves room with
 * `pb-20`), in the header of a wide screen (`top`). Unread messages show on People.
 */
export function RiderTabs({ unread, placement }: { unread: number; placement: 'top' | 'bottom' }) {
  if (placement === 'top')
    return (
      <nav aria-label="Your account" className="hidden items-center gap-1 rounded-full bg-card2 p-1 md:flex">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-bold ${isActive ? 'bg-brand text-on-brand shadow-soft' : 'text-muted hover:text-ink'}`}
          >
            {t.label}
            {t.to === '/me/people' && <Unread n={unread} className="min-w-4" />}
          </NavLink>
        ))}
      </nav>
    );
  return (
    <nav aria-label="Your account" className="fixed inset-x-0 bottom-0 z-20 border-t border-line bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden">
      <div className="mx-auto flex max-w-xl justify-around">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => `flex flex-1 flex-col items-center gap-0.5 py-2 text-xs font-bold ${isActive ? 'text-accent-text' : 'text-muted'}`}
          >
            {({ isActive }) => (
              <>
                <span className={`relative flex h-7 w-12 items-center justify-center rounded-full ${isActive ? 'bg-brand text-on-brand' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d={t.icon} />
                  </svg>
                  {t.to === '/me/people' && <Unread n={unread} className="absolute -top-1 right-0.5 min-w-4" />}
                </span>
                {t.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
